import React, { useState, useEffect } from "react";
import {
  platformData,
  getCurrencyVolumeTraded,
  getTotalFeesCollected,
} from "../CreateNfts/contractData";
import styled from "styled-components";
import BannerDashboard from "./BannerDashboard";
import DashboardGraph from "./DashboardGraph";
import DashboardTopSection from "./DashboardTopSection";
import RecentCollection from "./RecentCollection";
import { TopAuction } from "./TopAuction";
import RightBackgroundImage from "../../Images/backgroundImage.jpg";

const Dashboard = ({ allContractDetails }) => {
  const [sold, setTotalSold] = useState("");
  const [otherData, setOtherData] = useState("");

  const Root = styled.div`
    background-image: url(${RightBackgroundImage});
    background-size: cover;
    background-position: center;
  `;
  const GraphTopAuctionWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: center;
    /* margin: 25px 15px; */
  `;

  const array = [
    "0x0000000000000000000000000000000000001010",
    "0xc2132D05D31c914a87C6611C10748AEb04B58e8F",
    "0xca082498a1dE55c5d13C5AF2B10CA5e1957349E6",
  ];
  const currencyName = ["MATIC", "USDT", "MLD"];
  useEffect(() => {
    if (allContractDetails?.metaspaceNFTMarketplaceContract) {
      getAllNftMarketplaceList();
    }
  }, []);

  useEffect(() => {
    if (allContractDetails?.metaspaceNFTMarketplaceContract) {
      getAllNftMarketplaceList();
    } else {
      setTotalSold("");
      setOtherData("");
    }
  }, [allContractDetails]);

  const getAllNftMarketplaceList = async () => {
    const platForm = await platformData(
      allContractDetails.metaspaceNFTMarketplaceContract
    );
    setTotalSold(parseInt(platForm["totalNFTSold"]));
    let updatedArr = [];

    array.map(async (currency, i) => {
      const currencyVolume = await getCurrencyVolumeTraded(
        allContractDetails.metaspaceNFTMarketplaceContract,
        currency
      );

      const totalFees = await getTotalFeesCollected(
        allContractDetails.metaspaceNFTMarketplaceContract,
        currency
      );

      updatedArr.push({
        address: currency,
        name: currencyName[i],
        transaction: parseInt(currencyVolume),
        platformFeesEarned: parseInt(totalFees["platformFeesEarned"]),
        royaltyEarned: parseInt(totalFees["royaltyEarned"]),
      });

      setOtherData([...updatedArr]);
    });
  };
  return (
    <Root>
      <BannerDashboard />
      <DashboardTopSection sold={sold} otherData={otherData} />
      <GraphTopAuctionWrapper>
        <DashboardGraph />
        <TopAuction />
      </GraphTopAuctionWrapper>
      {/* <RecentCollection /> */}
    </Root>
  );
};

export default Dashboard;
